export const getInitials = (name: string) => {
  const indexOfSpace = name.indexOf(' ');
  return `${name.substr(0, 1)}${
    indexOfSpace !== -1 ? name.substr(indexOfSpace + 1, 1) : ''
  }`.toUpperCase();
};
